import { filtersHelper } from '@/utils';
import { companyModel } from '@/models/api/company.model';
import { departmentModel } from '@/models/api/department.model';
import { officeModel } from '@/models/api/office.model';

export const candidateJobModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    location: data.location,
    openings: data.openings,
    allowance: data.allowance,
    minSalary: data.min_salary,
    maxSalary: data.max_salary,
    closingDate: filtersHelper.getDateFormat(data.closing_date),
    description: data.description,
    tags: (data.tags ?? []).map(item => item),
    isIntern: data.is_intern,
    isFreshGraduate: data.is_fresh_graduate,
    isPublished: data.is_published,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    company: data.company ? companyModel(data.company) : null,
    department: data.department ? departmentModel(data.department) : null,
    office: data.office ? officeModel(data.office) : null,
});